import { useEffect, useState } from "react";
import { QrCode, KeyRound } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import MediaUpload from "@/components/MediaUpload";
import { fileUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Settings() {
  const [qr, setQr] = useState("");
  const [upi, setUpi] = useState("");
  const [uploaded, setUploaded] = useState("");
  const [busy, setBusy] = useState(false);
  const [pw, setPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [pwBusy, setPwBusy] = useState(false);

  useEffect(() => { api.get("/payment-qr").then(({ data }) => { setQr(data.qr || ""); setUpi(data.upi || ""); }); }, []);

  const changePassword = async () => {
    if (pw.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (pw !== confirmPw) { toast.error("Passwords do not match"); return; }
    setPwBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      toast.success("Admin password changed");
      setPw(""); setConfirmPw("");
    } catch (e) { toast.error(apiError(e)); }
    setPwBusy(false);
  };

  const save = async () => {
    setBusy(true);
    try {
      const value = uploaded ? uploaded : qr;
      await api.put("/admin/payment-qr", { value, upi });
      toast.success("Payment QR updated");
      setQr(value); setUploaded("");
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };

  return (
    <div className="space-y-5 max-w-lg">
      <div><h1 className="font-heading text-2xl font-extrabold flex items-center gap-2"><QrCode className="h-6 w-6 text-primary" /> Payment QR Settings</h1><p className="text-muted-foreground text-sm font-medium">This QR is shown to sellers on every payment screen. They scan, pay and upload a screenshot.</p></div>

      <div className="bg-card border rounded-2xl p-6 space-y-4">
        <div>
          <Label>UPI ID</Label>
          <Input data-testid="settings-upi" value={upi} onChange={(e) => setUpi(e.target.value)} placeholder="cleartile@upi" />
        </div>
        <div>
          <Label>QR Image URL</Label>
          <Input data-testid="settings-qr-url" value={qr} onChange={(e) => setQr(e.target.value)} placeholder="https://…" />
        </div>
        <div>
          <Label>…or upload a QR image</Label>
          <MediaUpload testId="settings-qr-upload" label="" kind="image" value={uploaded} onChange={setUploaded} />
        </div>
        {(uploaded || qr) && <img src={fileUrl(uploaded || qr)} alt="QR preview" className="w-56 h-56 object-contain rounded-xl border bg-white p-3" />}
        <Button data-testid="save-qr" onClick={save} disabled={busy} className="font-bold">{busy ? "Saving…" : "Save Payment QR"}</Button>
      </div>

      <div className="bg-card border rounded-2xl p-6 space-y-4">
        <div><h2 className="font-heading text-lg font-bold flex items-center gap-2"><KeyRound className="h-5 w-5 text-primary" /> Change Admin Password</h2><p className="text-muted-foreground text-sm font-medium">Update the password for this admin account.</p></div>
        <div>
          <Label>New Password</Label>
          <Input data-testid="admin-new-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="At least 6 characters" />
        </div>
        <div>
          <Label>Confirm New Password</Label>
          <Input data-testid="admin-confirm-password" type="password" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} placeholder="Re-enter new password" />
        </div>
        <Button data-testid="admin-change-password" onClick={changePassword} disabled={pwBusy} className="font-bold">{pwBusy ? "Saving…" : "Update Password"}</Button>
      </div>
    </div>
  );
}
